const GET_MY_PERMISSIONS = `
  query getMyPermissions($resources: [String]) {
    getMyPermissions(resources: $resources) {
      resource
      action
      granted
    }
  }
`;

export { GET_MY_PERMISSIONS };
